import { useState } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useIsRTL } from "@/hooks";

export const PasswordInput: React.FC<{
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  invalid?: boolean;
}> = ({ value, onChange, invalid }) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation("auth");
  const isRTL = useIsRTL();

  return (
    <div className={cn("form_group", "pwd_group")}>
      <input
        dir={isRTL ? "rtl" : "ltr"}
        type={show ? "text" : "password"}
        name="password"
        className={cn("form_control", { borderRed: invalid })}
        placeholder={t("passwordTab") + "*"}
        value={value}
        onChange={onChange}
      />
      <button
        type="button"
        className="show_toggle"
        onClick={() => setShow(v => !v)}
      >
        {show ? t("hide") : t("show")}
      </button>
    </div>
  );
};
